import React from "react";
import styled from "styled-components";
import ReactPaginate from "react-paginate";

import { PressItem } from "./components";
import { LEFT_ICON, RIGHT_ICON } from '../../icons'
import { BREAK_POINTS } from '../../constants';

const Wrapper = styled.div`
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.38px;
  text-align: center;
  color: #969696;
  margin: 60px 0 56px;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 18px;
    margin: 40px 0 32px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    font-size: 16px;
    margin: 32px 0 24px;
  }
`;

function PressPresenter({ press, count, currentPage, onPageChange, navigateToPressDetail }) {
  return (
    <Wrapper>
      <Title>PRESS</Title>
      <PressList press={press} navigateToPressDetail={navigateToPressDetail} />
      <Pagination count={count} currentPage={currentPage} onPageChange={onPageChange} />
    </Wrapper>
  );
};

const PressListWrapper = styled.section``;

const PressList = ({ press, navigateToPressDetail }) => {
  return (
    <PressListWrapper>
      {press.map((item) => (
        <PressItem key={item.id} item={item} navigateToPressDetail={navigateToPressDetail} />
      ))}
    </PressListWrapper>
  );
};

const PaginationWrapper = styled.section`
  margin: 40px 0 0;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .active {
    color: #7172a5;
  }

  li {
    margin: 0 8px;
    color: #c8c8c8;
    cursor: pointer;

    /* @media (max-width: ${BREAK_POINTS.MOBILE}px) {
      margin: 0 4px;
    } */
  }
`;

const Pagination = ({ count, currentPage, onPageChange }) => {
  if (!count || count <= 1) return null;
  return (
    <PaginationWrapper>
      <ReactPaginate
        onPageChange={onPageChange}
        forcePage={(currentPage || 1) - 1}
        previousLabel={<Icon icon={LEFT_ICON} />}
        nextLabel={<Icon icon={RIGHT_ICON} />}
        breakLabel={"..."}
        pageCount={count}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        breakClassName={"break-me"}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
    </PaginationWrapper>
  );
};

const IconWrapper = styled.img`
  width: 32px;
  height: 32px;

  /* @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 28px;
    height: 28px;
  } */

  /* @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: 24px;
    height: 24px;
  } */
`;

const Icon = ({ icon }) => <IconWrapper src={icon} alt="icon" />

export default PressPresenter;
